import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

import { ApiCaller } from '@graphit/callers'

export const meQueryOptions = queryOptions({
	queryKey: ['me'],
	queryFn: ApiCaller.getMe
})

export const useMeQuery = () => useSuspenseQuery(meQueryOptions)
